import { useEffect, useState } from "react"
import { AlgoBuilderLogo } from "@/components"
import { api } from "../system/api.js"
import { checkoutSession } from "../system/checkoutSession.js"

export default function SubscribeComplete() {
    const [processing, setProcessing] = useState(true)
    const [complete, setComplete] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {

        const searchParams = new URLSearchParams(window.location.search)
        const paymentIntentId = searchParams.get('payment_intent')
        const redirectStatus = searchParams.get('redirect_status')

        if (!paymentIntentId || redirectStatus !== 'succeeded') {
            setError('We could not complete your subscription. Please try again.')
            setProcessing(false)
            return
        }

        api('subscribe/checkout/confirm', { paymentId: paymentIntentId }).then(() => {
            checkoutSession.removePid()
            setComplete(true)
        }).catch(() => {
            setError('Failed to complete subscription.')
        }).finally(() => {
            setProcessing(false)
        })

    }, [])

    const redirect = url => {
        window.location.href = url
    }

    return (
        <>
        <header className="border-b border-border">
            <div className="max-w-5xl mx-auto px-4 py-4 flex items-center">
                <AlgoBuilderLogo height={22} />
            </div>
        </header>
        <div className="max-w-[1328px] mx-auto px-4">
            {processing && <div>Processing Payment...</div>}
            {complete && (
                <>
                    <div>Your payment was successfully processed!</div>
                    <button className="inline-flex items-center justify-center relative border-0 cursor-pointer appearance-none font-[inherit] text-[0.9375rem] select-none px-4 py-2 rounded-lg transition-all duration-250 bg-base-500 dark:bg-base-dark-500 text-base-content dark:text-base-dark-content whitespace-nowrap hover:bg-base-600 dark:hover:bg-base-dark-600" onClick={() => redirect('/')}>Go to Dashboard</button>
                </>
            )}
            {error && (
                <>
                    <p className="error">{error}</p>
                    <button className="inline-flex items-center justify-center relative border-0 cursor-pointer appearance-none font-[inherit] text-[0.9375rem] select-none px-4 py-2 rounded-lg transition-all duration-250 bg-base-500 dark:bg-base-dark-500 text-base-content dark:text-base-dark-content whitespace-nowrap hover:bg-base-600 dark:hover:bg-base-dark-600" onClick={() => redirect('/subscribe')}>Go to Checkout</button>
                </>
            )}
        </div>
        </>
    )

}
